import httpClient from '../httpClient';

export async function getAllPdp() {
  try {
    const response = await httpClient.get(`/api/produtopdp`);
    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getPdp(pdpId: string) {
  try {
    const response = await httpClient.get(`/api/produtopdp/${pdpId}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registros: ' + error);
  }
}

export async function getProdutosDoPdp(id: string) {
  try {
    const response = await httpClient.get(`/api/produtopdprl/pdp/${id}`);

    const dadosOrdenados = (response.data as any[]).sort((a, b) => {
      const nomeA = a.produtoDAF?.produtoFarmaceutico?.toUpperCase() || '';
      const nomeB = b.produtoDAF?.produtoFarmaceutico?.toUpperCase() || '';
      return nomeA.localeCompare(nomeB);
    });

    console.log(dadosOrdenados);
    return dadosOrdenados;
  } catch (error) {
    throw new Error('Erro ao obter Produtos do Kit: ' + error);
  }
}

export async function getAllPdpsPorProdutoId(id: string | number) {
  try {
    // Garante que o ID é um número válido antes de enviar para a API
    const produtoId = Number(id);
    if (isNaN(produtoId)) {
      throw new Error('ID do produto inválido');
    }

    const response = await httpClient.get(
      `/api/produtopdp/produtodaf/${produtoId}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error(
      'Erro ao obter lista de PDPs por ID do Produto Farmacêutico: ' + error,
    );
  }
}
